export function mergeArray(...arrays) {
  return Array.from(new Set(arrays.flat()));
}

export const isEqualArray = (a, b) => {
  if (a.length !== b.length) return false;
  const setA = new Set(a);
  return b.every((v) => setA.has(v));
};
